import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { Controller } from "react-hook-form"


export const Disclaimer = ({  control, errors }) => {
  return (
    <section className="DisclaimerSection">
      <div className="grid">
        <div className="col CheckboxRow"
        style={{
          alignItems: 'center',
        }}>
          <Controller
            name="authorization"
            control={control}
            rules={{ required: 'Este campo es requerido' }}
            defaultValue={false}
            render={({ field }) => (
              <Checkbox
                inputId="authorization"
                onChange={(e) => field.onChange(e.checked)}
                checked={field.value}
                className={errors.authorization ? 'p-invalid' : ''}
                style={{
                  borderColor: errors.authorization ? '#d9505e' : undefined,
                }}
              />
            )}
          />
          <span className="BlackText">
            Declaración de veracidad de información
          </span>
        </div>
      </div>

      <div className="grid">
        <div className="col Paragraph">
          <span className="Disclaimer">
            Autorizo expresamente a CONDUCE CAPITAL
            SAPI DE CV., para llevar a cabo investigaciones sobre mi
            comportamiento crediticio en las sociedades de información
            crediticia (SIC) que estime conveniente. Conozco la naturaleza y
            alcance de la información que se solicitará, del uso se le dará y
            que se podrán realizar consultas periódicas de mi historial
            crediticio. Consiento que esta autorización tenga una vigencia de
            3 años contados a partir de hoy, y en su caso mientras mantengamos
            relación jurídica. Acepto que este documento queda bajo propiedad
            de CONDUCE CAPITAL SAPI DE CV. para efectos de control y
            cumplimiento del artículo 28 de la LRSIC.d
          </span>
        </div>
      </div>

     
    </section>
  )
}